var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.49,
    height: 14.814,
    viewBox: "0 0 24.49 14.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3773.75 165.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2892.5 -275.186)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 21.99,
    transform: "translate(882.5 111.186)",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x2: 9.676,
    transform: "translate(888.5 123.5)",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x2: 17.592,
    transform: "translate(884.5 117.344)",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterWhite);
export default __webpack_public_path__ + "static/media/filter-white.b793a6f88a703d57fad71949009a6efc.svg";
export { ForwardRef as ReactComponent };